(function () {
  'use strict';

  if (window.WGSReferralService) {
    return;
  }

  const service = {
    timeout: 8000,     // 缩短超时时间，避免前端无休止等待
    interval: 200,

    /**
     * 等待 GoAffPro SDK 加载并获取访客/联盟会员数据
     */
    waitForVisitor: function () {
      return new Promise(function (resolve, reject) {
        const start = Date.now();

        function check() {
          // 1. 检查标准的 GoAffPro 挂载对象
          if (window.goaffpro) {
            // 如果存在 visitor 数据对象
            if (window.goaffpro.visitor) {
              resolve(window.goaffpro.visitor);
              return;
            }
            // 部分情况下如果已经初始化但用户未登录，主动放行返回空对象（代表游客状态）
            if (window.goaffpro.initialized || typeof window.goaffpro.getVisitor === 'function') {
              // 尝试直接调用其可能存在的获取方法，若无则传空
              if (typeof window.goaffpro.getVisitor === 'function') {
                window.goaffpro.getVisitor().then(function(v) {
                  resolve(v || {});
                }).catch(function() {
                  resolve({});
                });
                return;
              }
            }
          }

          // 2. 超时未找到则返回空对象（作为游客降级处理，而不是直接抛出 Reject 导致整个页面组件瘫痪）
          if (Date.now() - start >= service.timeout) {
            console.warn('[WGS Referral] GoAffPro visitor service timeout. Falling back to guest mode.');
            resolve({}); 
            return;
          }

          window.setTimeout(check, service.interval);
        }

        check();
      });
    },

    /**
     * 安全转换数字，防止数据格式异常
     */
    number: function (value) {
      if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
      }

      if (typeof value === 'string') {
        const parsed = Number.parseFloat(value.replace(/[^0-9.-]/g, ''));
        return Number.isFinite(parsed) ? parsed : 0;
      }

      return 0;
    },

    /**
     * 兼容获取推广链接的各种字段命名
     */
    referralUrl: function (visitor) {
      if (!visitor) return '';
      return (
        visitor.referral_url ||
        visitor.referralUrl ||
        visitor.referral_link ||
        visitor.referralLink ||
        visitor.url ||
        ''
      );
    },

    /**
     * 数据归一化处理
     */
    normalize: function (visitor) {
      const safeVisitor = visitor || {};
      const referralUrl = service.referralUrl(safeVisitor);

      return {
        isLoggedIn: Boolean(safeVisitor.id || safeVisitor.email || referralUrl),
        referralUrl: referralUrl,
        hasReferralUrl: Boolean(referralUrl),

        available: service.number(
          safeVisitor.balance ||
          safeVisitor.available_balance ||
          safeVisitor.availableBalance
        ),

        pending: service.number(
          safeVisitor.pending_earnings ||
          safeVisitor.pending_balance ||
          safeVisitor.pendingEarnings
        ),

        lifetime: service.number(
          safeVisitor.total_earnings ||
          safeVisitor.totalEarnings ||
          safeVisitor.lifetime_earnings
        )
      };
    },

    /**
     * 获取当前用户的推广资料
     */
    getProfile: async function () {
      try {
        const visitor = await service.waitForVisitor();
        return service.normalize(visitor);
      } catch (error) {
        console.warn('[WGS Referral] Get profile warning:', error);
        return service.normalize({});
      }
    },

    /**
     * 生成产品专属的带参推荐链接 (Deep Link)
     */
    createDeepLink: function (destination, referralUrl) {
      if (!destination || !referralUrl) {
        return '';
      }

      try {
        const product = new URL(destination, window.location.origin);
        const referral = new URL(referralUrl, window.location.origin);

        referral.searchParams.forEach(function (value, key) {
          product.searchParams.set(key, value);
        });

        if (referral.hash && !product.hash) {
          product.hash = referral.hash;
        }

        return product.toString();
      } catch (error) {
        console.warn('[WGS Referral] Deep link failed.', error);
        return '';
      }
    }
  };

  window.WGSReferralService = service;
})();